import * as yup from 'yup';

export const createContactFormSchema = (t: (key: string) => string) => {
	return yup.object().shape({
		name: yup
			.string()
			.required(t('contactSection.form.validation.nameRequired'))
			.max(50, t('contactSection.form.validation.nameMaxLength')),
		lastName: yup
			.string()
			.required(t('contactSection.form.validation.lastNameRequired'))
			.max(50, t('contactSection.form.validation.lastNameMaxLength')),
		email: yup
			.string()
			.required(t('contactSection.form.validation.emailRequired'))
			.email(t('contactSection.form.validation.emailInvalid'))
			.max(50, t('contactSection.form.validation.emailMaxLength')),
		company: yup
			.string()
			.required(t('contactSection.form.validation.companyRequired'))
			.max(50, t('contactSection.form.validation.companyMaxLength')),
		message: yup
			.string()
			.required(t('contactSection.form.validation.messageRequired'))
			.max(1000, t('contactSection.form.validation.messageMaxLength'))
	});
};

// Legacy export for backwards compatibility
export const schema = yup.object().shape({
	name: yup.string().required('Por favor ingresa tu nombre').max(50, 'Por favor ingresa como máximo 50 caracteres'),
	lastName: yup
		.string()
		.required('Por favor ingresa tu apellido')
		.max(50, 'Por favor ingresa como máximo 50 caracteres'),
	email: yup
		.string()
		.required('Por favor ingresa tu email')
		.email('Por favor ingresa un email válido')
		.max(50, 'Por favor ingresa como máximo 50 caracteres'),
	company: yup.string().required('Por favor ingresa tu empresa').max(50, 'Por favor ingresa como máximo 50 caracteres'),
	message: yup
		.string()
		.required('Por favor escriba un breve mensaje')
		.max(1000, 'Por favor ingresa como máximo 1000 caracteres')
});

export default createContactFormSchema;
